const MEA_REGION = 'MEA';
const EMEA_REGION = 'EMEA';

/**
 * Adjusts MEA locales to EMEA for compatibility with date formatting
 * @param locale - The original locale string
 * @returns The adjusted locale with MEA replaced by EMEA
 */
export const adjustMEALocales = (locale: string): string => {
  return locale.replace(MEA_REGION, EMEA_REGION);
};
